module.exports = __webpack_public_path__ + "img/uba.692545e0.png";